import { SEPARATOR__horizontal } from '@/pages/_base/separators/SEPARATOR__horizontal';
import { SEPARATOR__horizontal_dashed } from '@/pages/_base/separators/SEPARATOR__horizontal_dashed';
import { UTILS__ml_asset } from '@/utils/UTILS__ml_asset';
import { DTO__ml_asset_lora_tag_frequency } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset_lora_tag_frequency';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { G_UI_FIELD__token_list_add_lora_tag_block_item } from './G_UI_FIELD__token_list_add_lora_tag_block_item';

interface PROPS {
  field: FIELD__list_token;
  hash_sha256: string;
  tags: DTO__ml_asset_lora_tag_frequency[];
}

export function G_UI_FIELD__token_list_add_lora_tag_block({ hash_sha256, tags, field }: PROPS) {
  let [name, version] = UTILS__ml_asset.get_name_and_version(hash_sha256);

  tags = DTO__ml_asset_lora_tag_frequency.filter_by_largest_gap(tags);

  return (
    <div className="flex flex-col px-1 text-xs ">
      <SEPARATOR__horizontal />
      <div className="text-bar-foreground">
        lora: {name}
        {version}
      </div>
      <SEPARATOR__horizontal_dashed />
      {tags.map(tag => (
        <G_UI_FIELD__token_list_add_lora_tag_block_item {...{ field, tag, hash_sha256 }} key={`lora_block_item_${hash_sha256}_${tag.word}`} />
      ))}
    </div>
  );
}
